/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LobAndOfficePermission
 */
export interface LobAndOfficePermission {
    /**
     * 
     * @type {string}
     * @memberof LobAndOfficePermission
     */
    lobKey: string;
    /**
     * 
     * @type {string}
     * @memberof LobAndOfficePermission
     */
    officeKey: string;
    /**
     * 
     * @type {boolean}
     * @memberof LobAndOfficePermission
     */
    allow: boolean;
}

/**
 * Check if a given object implements the LobAndOfficePermission interface.
 */
export function instanceOfLobAndOfficePermission(value: object): value is LobAndOfficePermission {
    if (!('lobKey' in value) || value['lobKey'] === undefined) return false;
    if (!('officeKey' in value) || value['officeKey'] === undefined) return false;
    if (!('allow' in value) || value['allow'] === undefined) return false;
    return true;
}

export function LobAndOfficePermissionFromJSON(json: any): LobAndOfficePermission {
    return LobAndOfficePermissionFromJSONTyped(json, false);
}

export function LobAndOfficePermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): LobAndOfficePermission {
    if (json == null) {
        return json;
    }
    return {
        
        'lobKey': json['lobKey'],
        'officeKey': json['officeKey'],
        'allow': json['allow'],
    };
}

export function LobAndOfficePermissionToJSON(json: any): LobAndOfficePermission {
    return LobAndOfficePermissionToJSONTyped(json, false);
}

export function LobAndOfficePermissionToJSONTyped(value?: LobAndOfficePermission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lobKey': value['lobKey'],
        'officeKey': value['officeKey'],
        'allow': value['allow'],
    };
}

